import type { DecisionTreeDisclaimerSceneProps } from './decision-tree-disclaimer-scene-props.types';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useProvider } from '@provider-directory/contexts/ProviderContext';
import { useOrgContextBasedOnHospitalAssociations } from '../org-context/org-context-provider';
import { DecisionTreeContainer } from './decision-tree-container';
import { DecisionTreeHeader } from './decision-tree-header';

interface DecisionTreeDisclaimerProps extends DecisionTreeDisclaimerSceneProps {
  autoFocusHeading?: boolean;
}

export const DecisionTreeDisclaimer = ({
  title,
  body,
  autoFocusHeading,
}: DecisionTreeDisclaimerProps): ReactElement => {
  const { provider } = useProvider();
  const { key } = useOrgContextBasedOnHospitalAssociations(
    provider?.hospitalAssociations,
  );
  const { t } = useTranslation(key);
  return (
    <DecisionTreeContainer>
      <DecisionTreeHeader autoFocus={autoFocusHeading}>
        {t(title)}
      </DecisionTreeHeader>
      <div className={'whitespace-pre-line text-body-medium text-neutral-950'}>
        {t(body)}
      </div>
    </DecisionTreeContainer>
  );
};
